import * as THREE from 'three';

export default function canvas() {
  let camera, scene, renderer ,timer = 0;
  let particles = [];
  const dom = document.getElementById('particleCanvas')

  if(dom){
    init();
    animate();
  }

  function init() {
    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    camera.position.z = 8;

    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setSize(window.innerWidth, window.innerHeight);
    dom.appendChild(renderer.domElement);

    // パーティクルを生成する関数
    function createParticle() {
      const geometry = new THREE.CircleGeometry(0.08, 32); // 粒子の形状を指定
      const material = new THREE.MeshBasicMaterial({ color: Math.random() * 0xffffff }); // ランダムな色を設定
      const particle = new THREE.Mesh(geometry, material);
      particle.velocity = new THREE.Vector3((Math.random() - 0.5) * 0.1, (Math.random() - 0.5) * 0.1, (Math.random() - 0.5) * 0.1); // ランダムな速度を設定
      scene.add(particle);
      particles.push(particle);
    }

    // 初期状態で100個の粒子を生成
    for (let i = 0; i < 128; i++) {
      createParticle();
    }
  }

  function animate() {
    requestAnimationFrame(animate);

    // パーティクルの移動
    particles.forEach((particle) => {
      particle.position.add(particle.velocity);
      // 画面外に出たら再び画面内に戻す
      if (particle.position.x < -10 || particle.position.x > 10 ||
          particle.position.y < -10 || particle.position.y > 10 ||
          particle.position.z < -10 || particle.position.z > 10) {
        particle.position.set(0, 0, 0);
        particle.velocity = new THREE.Vector3((Math.random() - 0.5) * 0.1, (Math.random() - 0.5) * 0.1, (Math.random() - 0.5) * 0.1);
      }
    });

    renderer.render(scene, camera);
  }

  window.addEventListener('resize', onWindowResize);
  function onWindowResize() {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
  }
}
